import { Route, Switch } from 'react-router-dom';
import ProtectedRoute from '@/utils/ProtectedRoute';
import { usePermissions } from '@/providers/Permissions.provider';
import AccountsContainer from './Accounts/AccountsContainer';
import TransferPage from './Accounts/Transfer/TransferPage';
import { PartnerAccountsProvider } from './providers/PartnerAccounts.provider';
import { TRANSFER_PATH } from './paths';

// The redesigned Accounts pages read their own PartnerAccountsProvider: the app-wide one keeps the
// contract the menu-linked pages were built against.
export default function Routes() {
  const { permissions } = usePermissions();

  return (
    <PartnerAccountsProvider>
      <Switch>
        <ProtectedRoute
          isAllowed={!!permissions.AccountTransfersEnabled}
          showPermission
          exact
          path={TRANSFER_PATH}
          component={TransferPage}
        />

        <Route>
          <AccountsContainer />
        </Route>
      </Switch>
    </PartnerAccountsProvider>
  );
}
